import { ActionsPage } from '../'
import { branch } from '../constants'

module.exports = (transaction) ->

  (await ActionsPage.list({ transaction }))
    .filter((configNode) -> configNode.get('component') is 'upload_transformations_file')
    .map((configNode) ->
      configNode.set('component', 'upload_file')
      configNode.save({ transaction, branch })
    )
